import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import createAction from './';

const SERVICE_WORKER_REGISTRATION = createAsyncAction(createAction('SERVICE_WORKER_REGISTRATION'));

const waitUntilRegister = (registration) => new Promise((resolve, reject) => {
  const serviceWorker = registration.installing || registration.waiting || registration.active;

  if (!serviceWorker) {
    return reject(new Error('Service worker is not supported'));
  }

  if (serviceWorker.state === 'redundant') {
    return reject(new Error('Service worker is redundant'));
  }

  if (serviceWorker.state === 'activated') {
   return resolve(registration);
  }

  let stateChangeListener;

  const unsubscribe = () => serviceWorker
    .removeEventListener('statechange', stateChangeListener);

  stateChangeListener = () => {
    if (serviceWorker.state === 'activated') {
      unsubscribe();
      return resolve(registration);
    } if (serviceWorker.state === 'redundant') {
      unsubscribe();
      return reject(new Error('Service worker is redundant'));
    }
  };

  serviceWorker.addEventListener('statechange', stateChangeListener);
  resolve();
});

export const workerRegistration = () => (dispatch) => {
    dispatch({ type: SERVICE_WORKER_REGISTRATION.pending });

    return navigator
      .serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(waitUntilRegister)
      .then(() => dispatch({ type: SERVICE_WORKER_REGISTRATION.success }))
      .catch((err) => {
        dispatch(errorAction(SERVICE_WORKER_REGISTRATION.failure, err));
        throw err;
      });
};
